import React, { Component } from "react"
import PropTypes from "prop-types"
import Checkbox from "../input/Checkbox"
import _ from "lodash"

import { buildFormControllClass } from "../../helpers/formUtils"

class FieldGroupCheckbox extends Component {
  constructor(props) {
    super(props)

    this.state = {
      checkedValues: [],
    }

    this.onValueChange = this.onValueChange.bind(this)
    this.onFocusOut = this.onFocusOut.bind(this)
  }

  onValueChange(val, checked) {
    const { checkedValues } = this.state
    const { id, onChange } = this.props

    if (!checked) {
      _.pull(checkedValues, val)
    } else if (!~_.indexOf(checkedValues, val)) {
      checkedValues.push(val)
    }

    onChange(id, checkedValues)
    this.setState({ checkedValues })
  }

  onFocusOut(el) {
    const { id, onFocusOut } = this.props

    onFocusOut(id, el)
  }

  isChecked(val) {
    const { value } = this.props
    if (typeof value === "string") return value === val
    return _.indexOf(value, val) !== -1
  }

  render() {
    const {
      className,
      label,
      hidden,
      required,
      options,
      hide_label,
      valid,
    } = this.props

    return (
      <div
        className={`form-control${buildFormControllClass(
          className,
          hidden,
          required,
          valid
        )}`}
      >
        {label && !hide_label && (
          <span
            className="form-control__label"
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}

        {options.map(o => (
          <Checkbox
            key={o.value}
            label={o.label}
            value={o.value}
            onChange={this.onValueChange}
            onFocusOut={this.onFocusOut}
            checked={this.isChecked(o.value)}
          />
        ))}
      </div>
    )
  }
}

FieldGroupCheckbox.defaultProps = {
  id: "",
  label: "",
  hidden: false,
  hide_label: false,
  name: "",
  readonly: false,
  required: false,
  onChange: () => {},
  onFocusOut: () => {},
  value: "",
  valid: true,
}

FieldGroupCheckbox.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  hidden: PropTypes.bool,
  required: PropTypes.bool,
  hide_label: PropTypes.bool,
  name: PropTypes.string,
  options: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.shape({
        imageUrl: PropTypes.string,
        value: PropTypes.string,
        label: PropTypes.string,
      })
    ),
  ]),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onChange: PropTypes.func,
  onFocusOut: PropTypes.func,
  valid: PropTypes.bool,
}

export default FieldGroupCheckbox
